import React, {ReactNode} from 'react'

import {Button} from '@daedalus/atlas/Button'
import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper'
import {Icon} from '@daedalus/atlas/Icon'
import {OverlayPage, OverlayPageContent} from '@daedalus/atlas/OverlayPage'
import {PopUp} from '@daedalus/atlas/PopUp'
import {
  BookingError,
  Psd2AuthStatusErrorType
} from '@daedalus/core/src/booking/types/ErrorResponse'

import {RecoverableErrorContentLayout} from './RecoverableErrorContentLayout'
import {SoldOutErrorContentLayout} from './SoldOutErrorContentLayout'

const POPUP_WIDTH = 480

export enum ErrorType {
  Recoverable = 'recoverable',
  NonRecoverable = 'non_recoverable'
}

interface PropsType {
  isOpen: boolean
  checkIn: string
  checkOut: string
  rooms: string
  onClick: () => void
  onShadeBackgroundClick?: () => void
  closeOnOutsideClick?: boolean
  bookingError?: BookingError | Psd2AuthStatusErrorType
  redirectOffersSlot: ReactNode
  hotelCardSlot: ReactNode
  isPayAtProperty?: boolean
}

export const AlternativeOffersOverlay = ({
  isOpen,
  checkIn,
  checkOut,
  rooms,
  onClick,
  onShadeBackgroundClick = () => {},
  closeOnOutsideClick = true,
  bookingError,
  redirectOffersSlot,
  hotelCardSlot,
  isPayAtProperty = false
}: PropsType) => {
  const {isMobile} = useDeviceLayout()

  const props = {
    checkIn,
    checkOut,
    rooms,
    onClick,
    redirectOffersSlot,
    hotelCardSlot,
    isPayAtProperty
  }

  const Content = bookingError ? (
    <RecoverableErrorContentLayout {...props} bookingError={bookingError} />
  ) : (
    <SoldOutErrorContentLayout {...props} />
  )

  return isMobile ? (
    <OverlayPage
      showCloseButton={false}
      onShadeBackgroundClick={onShadeBackgroundClick}
      isOpen={isOpen}
      titleBarProps={{
        startContent: (
          <Button variant="quiet" onClick={onClick}>
            <Icon name="ChevronLeft" />
          </Button>
        )
      }}
      hasHeaderBoxShadow={false}
    >
      <OverlayPageContent>{Content}</OverlayPageContent>
    </OverlayPage>
  ) : (
    <PopUp
      width={POPUP_WIDTH}
      isOpen={isOpen}
      closeAction={onClick}
      closeOnOutsideClick={closeOnOutsideClick}
    >
      <ContentWrapper paddingTop="s700">{Content}</ContentWrapper>
    </PopUp>
  )
}
